import React from 'react';

import type { IUser } from './types';

import ReusableTooltip from '../../reusables/Tooltip';

import ProfileAvatar from './components/avatar/ProfileAvatar';
import ProfileCards from './components/cards/ProfileCards';

import { Wrapper, WrapperHeader, WrapperMain, WrapperTooltip } from './styled';
import ProfileOptions from './components/options/ProfileOptions';

interface IProps {
  user?: IUser;
}

const ProfileView = ({ user }: IProps) => (
  <Wrapper>
    <WrapperHeader>
      <ProfileAvatar user={user} />
      <ProfileOptions user={user} />
    </WrapperHeader>
    <WrapperMain>
      <WrapperTooltip>
        <span>¿Quiénes pueden ver la información de mi perfil?</span>
        <ReusableTooltip
          text="Los datos que mostramos y que agregues, se guardarán en la base de datos de la Universidad y no se compartirán con otros. Sólo tú podrás ver esta información."
          width="300px"
        />
      </WrapperTooltip>
      <ProfileCards />
    </WrapperMain>
  </Wrapper>
);

export default ProfileView;
